// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iTh6WBB0A6SwiK {
  font: var(--ds-font-body, 400 14px / 20px -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-display: swap;
  font-weight: var(--ds-font-weight-bold, 700);
  margin-top: var(--ds-space-150, 12px);
  margin-bottom: var(--ds-space-050, 4px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  display: block;
  margin-bottom: var(--ds-space-050, 2px);
  color: var(--ds-text, #172b4d);
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
}
.YaGQx99cVlGuTq input,
.YaGQx99cVlGuTq input:focus {
  box-shadow: none;
}
.iZwWjLc9Yro24f {
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0);
}
.iZwWjLc9Yro24f li:hover {
  background: none;
}
.KCB2jk_nNrwDS0.fhc_cpWN8KsfB5 {
  padding: var(--ds-space-0, 0);
}
.J1YHCwqTjLF6is {
  background-color: var(--ds-background-disabled, #091e4208);
  color: var(--ds-text-disabled, #091e424f);
  pointer-events: none;
}
`, ""]);
// Exports
export var label = `iTh6WBB0A6SwiK`;
export var control = `YaGQx99cVlGuTq`;
export var menu = `iZwWjLc9Yro24f`;
export var option = `KCB2jk_nNrwDS0`;
export var noPadding = `fhc_cpWN8KsfB5`;
export var disabled = `J1YHCwqTjLF6is`;
export default ___CSS_LOADER_EXPORT___;
